module.exports = __webpack_public_path__ + "img/expressage.48c4be45.png";